import { ACTIONS, KEYS } from "../../_config";
import { ActionExtended } from "../../_config/interfaces/interfaces";

export interface AttributesReducer {
    attributes: any[] | null;
}

const initialState: AttributesReducer = {
    attributes: null,
};

const attributesReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.ATTRIBUTES.SEARCH_ATTRIBUTE:
            return {
                ...state,
                attributes: action.payload,
            };

        default:
            return state;
    }
};

export default attributesReducer;
